<template>
  <div v-html="instagramIframe">
    <!-- LightWidget WIDGET -->
    <!-- <iframe 
      src="//lightwidget.com/widgets/6d14e2faf41e5e3881204c5dadc22587.html" 
      scrolling="no" allowtransparency="true" class="lightwidget-widget" style="height:550px;width:100%;border:0;overflow:hidden;"
    />     -->
  </div>
</template>

<script>
  import axios from 'axios'
  import utils from '@/services/utils'
  export default {
    props: {
      data: {
        type: Object,
        required: true,
        default: null
      },
    },
    data: () => ({
      instagramIframe: null
    }),
    computed: {
      btnBackgroundColor () {        
        return this.$store.state.app.btnBackgroundColor && this.$store.state.app.btnBackgroundColor !== '' ? this.$store.state.app.btnBackgroundColor : this.BGColor
      },
      btnTextColor () {
        return this.$store.state.app.btnTextColor && this.$store.state.app.btnTextColor !== '' ? this.$store.state.app.btnTextColor : 'white'
      },    
    },
    watch: {
      'data.InstagramIframe': {
        handler (newValue) {
          this.instagramIframe = newValue ? newValue : null
        },
        deep: true
      }
    },
    mounted () {
      this.instagramIframe = this.data.InstagramIframe ? this.data.InstagramIframe : null
    }
  }
</script>
